import React, { useState, useEffect, useRef } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { Container, Row, Col, Spinner, Alert } from 'react-bootstrap'
import { amazonAPI } from '../api/amazonAPI'

function AmazonOAuthCallbackScreen() {
    const [searchParams] = useSearchParams()
    const [callbackStatus, setCallbackStatus] = useState('processing')
    const [message, setMessage] = useState('')
    const [accountId, setAccountId] = useState(null)
    const processedRef = useRef(false)

    useEffect(() => {
        if (processedRef.current) return
        processedRef.current = true

        const code = searchParams.get('code')
        const state = searchParams.get('state')
        const error = searchParams.get('error')

        if (error) {
            setCallbackStatus('error')
            setMessage(`Amazon authorization was denied: ${error}`)
            return
        }

        if (!code || !state) {
            setCallbackStatus('error')
            setMessage('Missing authorization code or account identifier in callback URL')
            return
        }

        setAccountId(state)

        const exchangeCode = async () => {
            try {
                const result = await amazonAPI.accounts.advertisingOAuthCallback(state, { code })
                let msg = result.message || 'Authorization successful'
                if (result.profile_id_set) {
                    msg += ` (Profile ${result.profile_id_set} auto-selected)`
                }
                setCallbackStatus('success')
                setMessage(msg)
            } catch (err) {
                setCallbackStatus('error')
                setMessage(
                    err.response?.data?.error ||
                    err.response?.data?.detail ||
                    'Failed to exchange authorization code'
                )
            }
        }

        exchangeCode()
    }, [searchParams])

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col style={{ maxWidth: '600px' }}>
                    <h2 className="mb-4">Amazon Advertising Authorization</h2>

                    {callbackStatus === 'processing' && (
                        <div className="text-center py-4">
                            <Spinner animation="border" role="status" className="mb-3" />
                            <p>Exchanging authorization code with Amazon...</p>
                        </div>
                    )}

                    {callbackStatus === 'success' && (
                        <>
                            <Alert variant="success">
                                <i className="fas fa-check-circle me-2"></i>
                                {message}
                            </Alert>
                            {accountId && (
                                <Link to={`/amazon-account/${accountId}`} className="btn btn-primary">
                                    <i className="fas fa-arrow-left me-2"></i>
                                    Back to Account
                                </Link>
                            )}
                        </>
                    )}

                    {callbackStatus === 'error' && (
                        <>
                            <Alert variant="danger">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                {message}
                            </Alert>
                            {accountId ? (
                                <Link to={`/amazon-account/${accountId}`} className="btn btn-outline-primary">
                                    <i className="fas fa-arrow-left me-2"></i>
                                    Back to Account
                                </Link>
                            ) : (
                                <Link to="/amazon-accounts" className="btn btn-outline-primary">
                                    <i className="fas fa-arrow-left me-2"></i>
                                    Back to Accounts
                                </Link>
                            )}
                        </>
                    )}
                </Col>
            </Row>
        </Container>
    )
}

export default AmazonOAuthCallbackScreen
